import React, { useEffect, useState } from 'react';
import styles from './Balance.module.scss';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { Credentials } from '../../types/Login';
import { Dispatch } from 'redux';
import { get, isEmpty } from 'lodash';
import 'react-multi-carousel/lib/styles.css';
//assets
import SVG from 'react-inlinesvg';
import Close from '../../assets/icons/close.svg';

import { Button } from '../../components/Button/Button';
//Tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';
//components
import { BalanceTableConnected } from './Charts/Balance/BalanceTable';

//data
import { DashboardState } from '../../store/dashboard/reducer';
import { dashboardActions } from '../../store/dashboard/actions';
import { LoginState } from '../../store/login/reducer';
//functions
import { formatNumber, amountFloatFormatter } from './Utils/dashboardUtils';
import { requestPayout } from '../../api/dashboard';
//tooltip
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
//assets
import money from '../../assets/cash.json';
import Lottie from 'react-lottie';
import { toast } from 'react-toastify';
import { WithdrawalMethodsModal } from './Utils/WithdrawalMethodModal';
import CurrencyFormat from 'react-currency-format';
import { useAnalyticsHandlers } from '../../analytics/__providers__/AnalyticsHandlersProvider';
import { CurrencyCode } from '../PaymentGateway/interfaces/currencies';
import { getCurrencyValue } from '../PaymentGateway/utils/functions';
import { BalanceSummary } from '../../sagas/dashboard/types';

export interface StateProps {
  user: Credentials;
  loading: boolean;
  dashboardState: DashboardState;
  loginState: LoginState;
}
export interface DispatchProps {
  getBalance: (cursor: any) => any;
  putBalance: (data: any) => any;
}
type BalanceProps = StateProps & DispatchProps;

export const Balance: React.FC<BalanceProps> = ({
  getBalance,
  dashboardState,
  loginState,
  putBalance,
}) => {
  const { t } = useTranslation();
  const analytics = useAnalyticsHandlers();
  const [isOpen, setIsOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [withdrawalValue, setWithdrawalValue]: any = useState('');
  const [page, setPage] = useState(1);
  const [popupStep, setPopupStep] = useState(1);

  const username = get(loginState, ['user', 'user', 'username']);
  const email = get(loginState, ['user', 'user', 'email']);
  const CustomTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: ' #242424',
      boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.3)',
      padding: 18,
      fontSize: 12,
    },
    arrow: {
      color: ' #242424',
    },
  }))(Tooltip);
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: money,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  const userId = get(loginState, ['user', 'user', 'id']);
  const country_code = get(loginState, ['user', 'user', 'country_code']);
  const currency: CurrencyCode = get(loginState, ['user', 'user', 'currency']);

  useEffect(() => {
    getBalance({ cursor: undefined });

    analytics!.client.BIEvent.log('PAYOUTS_PAGE_VISITED', {
      values: [null],
      userID: userId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const navigateToPage = (cursor: any) => {
    getBalance({ cursor: cursor });
  };

  const balanceSummary: BalanceSummary = get(dashboardState, [
    'balanceSummary',
  ]);

  const available =
    get(dashboardState, ['balanceSummary', 'availableBalance', 'amount']) || 0;
  const availableDecimals =
    get(dashboardState, ['balanceSummary', 'availableBalance', 'decimals']) ||
    0;
  const formattedAvailable = formatNumber(available, availableDecimals, false);
  const account = get(dashboardState, [
    'balanceSummary',
    'payoutMethod',
    'value',
  ]);
  const payoutMethod = get(dashboardState, [
    'balanceSummary',
    'payoutMethod',
    'type',
  ]);
  const MIN_WITHDRAWAL = {
    EUR: 200,
    BRL: 1000,
    MXN: 4000,
    USD: 200,
  };
  const isBelowMin = () =>
    available / Math.pow(10, availableDecimals) < MIN_WITHDRAWAL[currency];

  const isWithdrawalDisabled = () => {
    const parsedValue = amountFloatFormatter(withdrawalValue) || 0,
      parsedAvailable = amountFloatFormatter(formattedAvailable);
    return (
      !withdrawalValue.length ||
      parsedValue <= 0 ||
      parsedValue > parsedAvailable
    );
  };
  const parseWithdrawal = () => {
    let resStr = withdrawalValue;
    const rules = [
      { regex: /[^0-9.,]/g, repl: '' },
      { regex: '.', repl: '' },
      { regex: ',', repl: '.' },
    ];
    rules.forEach((rule) => {
      resStr = resStr.replace(rule.regex, rule.repl);
    });
    return parseFloat(resStr);
  };
  const handleWithdrawal = () => {
    requestPayout(parseWithdrawal())
      .then((res) => {
        setPopupStep(2);
        setPage(1);
        analytics!.client.BIEvent.log('PAYOUT_REQUESTED', {
          values: [null],
          userID: userId,
        });

        analytics?.client.Mixpanel.log('PAYOUT_REQUESTED', [
          {
            total_amount: parseWithdrawal(),
            tipster_currency: currency,
          },
        ]);

        setTimeout(() => {
          //refresh page info after a brief delay to reflect remaining balance
          getBalance({ cursor: undefined });
        }, 2000);
      })
      .catch((e: any) => toast.error(e.detail || e.message));
  };
  const handleSEditPayoutMethod = (data: any) => {
    putBalance(data);
  };
  return (
    <>
      {!isEmpty(balanceSummary) && (
        <div className={styles.container} id={styles.payouts}>
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <div>
                <h1>{tr(t, 'balance')}</h1>
              </div>
            </div>
            <div className={styles.notice}>
              <p>{tr(t, 'payouts-notice')}</p>
            </div>
          </div>
          <div className={styles.divisionLine}></div>
          <div className={styles.section}>
            <div className={styles.withdrawRow}>
              <div className={styles.withdrawColumn}>
                <div className={styles.flex}>
                  <label>{tr(t, 'total-income')}</label> {/* @ts-ignore */}
                </div>

                <label className={styles.moneyLabel}>
                  {balanceSummary.availableBalance.toString()}
                </label>

                <br />

                <span className={styles.withdrawInfo}>
                  {tr(t, 'available-to-withdraw_tooltip')}
                </span>
              </div>

              <div className={styles.withdrawWrapper}>
                <div>
                  <div>
                    <div>
                      <label>{tr(t, 'account-for-withdrawal')}</label>
                      {account && (
                        <button
                          onClick={() => setIsEditOpen(true)}
                          className={styles.editBtn}
                        >
                          {tr(t, 'edit')}
                        </button>
                      )}
                    </div>
                    {account ? (
                      <label>{account}</label>
                    ) : (
                      <button
                        onClick={() => setIsEditOpen(true)}
                        className={styles.editBtn}
                        id={styles.addBtn}
                      >
                        {tr(t, 'add')}
                      </button>
                    )}
                  </div>
                  <label>{payoutMethod}</label>
                </div>
                <div>
                  {isBelowMin() ? (
                    <CustomTooltip
                      title={`${tr(t, 'min_available-to-withdraw_tooltip')} ${
                        MIN_WITHDRAWAL[currency]
                      }${currency}`}
                      arrow
                      placement="bottom"
                      leaveDelay={500}
                      enterTouchDelay={0}
                    >
                      <div className={styles.disabledBtn}>
                        <label className={styles.withdrawBtnText}>
                          {tr(t, 'withdraw-balance')}
                        </label>
                      </div>
                    </CustomTooltip>
                  ) : (
                    <Button
                      className={styles.withdrawBalanceBtn}
                      theme="primary"
                      action={() => setIsOpen(!isOpen)}
                    >
                      <label className={styles.withdrawBtnText}>
                        {tr(t, 'withdraw-balance')}
                      </label>
                    </Button>
                  )}
                </div>
              </div>
            </div>
            {isOpen && (
              <div className={styles.modalOverlay}>
                <div className={styles.modalWrapper}>
                  <a // eslint-disable-line
                    onClick={() => {
                      setIsOpen(false);
                      setPopupStep(1);
                    }}
                  >
                    <SVG src={Close} />
                  </a>
                  {popupStep === 1 ? (
                    <div className={styles.modalTextWrapper}>
                      <p>{tr(t, 'withdraw-step1_info')}</p>
                      <div>
                        <CurrencyFormat
                          suffix={` ${currency}`}
                          placeholder={`Max. ${formattedAvailable} ${currency}`}
                          decimalSeparator={','}
                          decimalScale={2}
                          thousandSeparator={'.'}
                          onValueChange={(values: any) => {
                            const { formattedValue } = values;
                            setWithdrawalValue(formattedValue);
                          }}
                          max={formattedAvailable}
                          min={0}
                        />
                      </div>

                      <Button
                        theme="primary"
                        action={() => handleWithdrawal()}
                        disabled={isWithdrawalDisabled()}
                      >
                        <label className={styles.withdrawBtnText}>
                          {tr(t, 'withdraw_amount')}
                        </label>
                      </Button>
                    </div>
                  ) : (
                    <div className={styles.modalTextWrapper}>
                      <Lottie options={lottieOptions} />
                      <p>
                        {`${username} `}
                        {t('withdraw-step2_info')}
                        <strong>{` ${email} `}</strong>{' '}
                        {t('withdraw-step2_info2')}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
            {isEditOpen && (
              <WithdrawalMethodsModal
                setIsOpen={setIsEditOpen}
                isOpen={isEditOpen}
                loading={dashboardState.isLoading}
                country={country_code}
                handleSEditPayoutMethod={handleSEditPayoutMethod}
              ></WithdrawalMethodsModal>
            )}

            <BalanceTableConnected
              isLoading={dashboardState.isLoading}
              downloadAllCsv={dashboardState.allCsvSummary}
              transactionsData={dashboardState.balanceTransactions}
              isRequested={dashboardState.requested}
              navigateToPage={navigateToPage}
              page={page}
              setPage={setPage}
              userId={userId}
            />
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  dashboardState: state.dashboard,
  loginState: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getBalance: (cursor: any) =>
    dispatch(dashboardActions.balanceRequestAction(cursor)),
  putBalance: (data: any) =>
    dispatch(dashboardActions.putBalanceRequestAction(data)),
});

export const BalanceConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Balance);
